import { useEffect, useState } from 'react';
import { createWLog, apiResultSuccess } from '../apihelper';
import { FORM_MESSAGES, LABELS, UTILITY_CSS_CLASSES } from '../global/constants';
import { makeBEM, numberInputValid } from '../global/utils';


function WLogForm({ moduleName='wlog-form', boardId=-1, controller }) {

	const [valueInput, setValueInput] = useState('');
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [formData, setFormData] = useState({ value: '' });
	const [errors, setErrors] = useState({});
	const [formStatus, setFormStatus] = useState({});
	const [ctrl, setCtrl] = useState(false);

	const formWrapperClass = `form ${moduleName}`;
	const inputsWrapperClass = `${makeBEM('form', 'inputs-wrapper')} ${makeBEM(moduleName, 'inputs-wrapper')}`;
	const valueErrorClass = errors.value ? UTILITY_CSS_CLASSES.hasErrors : '';
	const valueInputClass = `input ${makeBEM(moduleName, 'value-input')} ${valueErrorClass}`;
	
	useEffect(() => {
		if ( controller ) {
			setCtrl(controller);
		}
	}, [controller])

	// Event handler for form input value change
	// Updates postData with new value
	const handleChange = (e) => {
		const { name, value } = e.target;
		const updatedFormData = { ...formData, [name]: value };
		setFormData(updatedFormData);
	}

	// Validates form checking for value field
	// Value field needs to present
	// And needs to be a number
	const validateForm = () => {
		const newErrors = {};

		if ( !formData.value ) {
			newErrors.value = FORM_MESSAGES.valueRequired;
		} else if ( !numberInputValid(formData.value) ) {
			newErrors.value = FORM_MESSAGES.valueInvalid;
		}

		return newErrors;
	}
	
	// Submit handler
	// Checks for validation errors
	// If none, calls submitNew
	const handleSubmit = (e) => {
		e.preventDefault();
		const validationErrors = validateForm();

		if ( Object.keys(validationErrors).length > 0 ) {
			setErrors(validationErrors);
		} else {
			setErrors({});

			const postData = { ...formData, board_id: boardId };
			submitNew(postData);
		}
	}

	// Calls API fn to create wlog
	// Updates form status before and after 
	// Upon succesful response sends it to controller
	const submitNew = (postData) => {
		setIsSubmitting(true);
		setFormStatus({ message: FORM_MESSAGES.newWLogSubmit });

		try {
			createWLog(
				(result) => {
	
					if ( apiResultSuccess(result) ) {

						setFormStatus({ message: FORM_MESSAGES.createdNewWLog })
						
						if ( result.wLog ) { 
							if ( ctrl ) {
								ctrl.addNew(result.wLog);
							}
						}
					}
				}, postData
			);
		} catch (error) {
			setFormStatus({ message: FORM_MESSAGES.failedSubmit });
		} finally {
			setIsSubmitting(false);
		}
	}

	// Returns form status message with priority below
	// Errors | Message | Instructrions
	const showFormStatus = () => {
		if ( errors.value ) {
			return errors.value
		}

		if ( formStatus.message ) {
			return formStatus.message;
		}

		return LABELS.wLogFormInstructions;
	}

	return (
		<div className={ formWrapperClass }>
			<form onSubmit={handleSubmit}>
				<div className={ inputsWrapperClass }>
					{/* <p 
						className={ `message ${makeBEM(moduleName, 'form-status')}` }
					>
						{  showFormStatus() }
					</p> */}
					<input
						id="value"
						name="value"
						type="number"
						className={valueInputClass}
						onChange={ handleChange }
						autoComplete="off"
						required
						placeholder={ LABELS.wLogValuePlaceHolder }
					/>
					<button
						className={ `btn ${makeBEM(moduleName, 'submit-btn')}` }
						onClick={handleSubmit}
						type="submit"
						disabled={isSubmitting}
					>
						{ LABELS.new }
					</button>
				</div>
			</form>
		</div>
	);
}

export default WLogForm;
